import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["summary", "form"]

  connect() {
    const isNew = this.element.classList.contains("new_record")
    if (isNew) {
      if (this.hasFormTarget) this.formTarget.style.display = "block"
      if (this.hasSummaryTarget) this.summaryTarget.style.display = "none"
      this.element.classList.remove("new_record")
      return
    }
    if (this.hasFormTarget) this.formTarget.style.display = "none"
    if (this.hasSummaryTarget) this.summaryTarget.style.display = "block"
  }

  show(event) {
    event.preventDefault()
    if (this.hasFormTarget) this.formTarget.style.display = "block"
    if (this.hasSummaryTarget) this.summaryTarget.style.display = "none"
  }
}
